import { prefs, setCategory } from "./state.js";
import { fetchCategories } from "./api.js";
import { escapeHtml } from "./util.js";

const catPicker = document.getElementById("catPicker");
const catBtn = document.getElementById("catBtn");
const catMenu = document.getElementById("catMenu");
const catLabel = document.getElementById("catLabel");

export async function initCategoryPicker(onChange) {
  try {
    const categories = await fetchCategories();
    catMenu.innerHTML = categories.map(c => `
      <button class="picker-item ${c === prefs.category ? "active" : ""}" data-cat="${escapeHtml(c)}" role="menuitem" type="button">${escapeHtml(c)}</button>
    `).join("");
    catMenu.querySelectorAll(".picker-item").forEach(btn => {
      btn.addEventListener("click", () => {
        const next = btn.dataset.cat;
        setCategory(next);
        catLabel.textContent = next;
        catMenu.querySelectorAll(".picker-item").forEach(b => b.classList.toggle("active", b === btn));
        catPicker.classList.remove("open");
        catBtn.setAttribute("aria-expanded", "false");
        onChange();
      });
    });
    catLabel.textContent = prefs.category;
  } catch {}

  catBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    const isOpen = catPicker.classList.toggle("open");
    catBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");
  });
  document.addEventListener("click", (e) => {
    if (!catPicker.contains(e.target)) {
      catPicker.classList.remove("open");
      catBtn.setAttribute("aria-expanded", "false");
    }
  });
}
